var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCaretBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04 0a.739.739 0 00-.526.22.758.758 0 000 1.067l4.631 4.689-4.677 4.739a.759.759 0 000 1.065.737.737 0 001.043.008l.009-.008 5.73-5.804L1.564.222A.739.739 0 001.04 0z",
    fill: "#15909E"
  })));
}

export default SvgIconCaretBlue;